import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
  invalidEmail: "فرمت ایمیل وارد شده معتبر نیست",
};

const schema = z.object({
  email: z.string().min(1, errorMessages.required).email(errorMessages.invalidEmail),
  password: z.string().min(1, errorMessages.required),
});

export { schema };
